import { useState } from 'react';

type PythonProps = {
  paddValue?: number;
};

export const Python4 = ({ paddValue }: PythonProps) => {
  const [pValue] = useState(20);
  const [sValue] = useState(12);

  return (
    <div style={{ paddingLeft: `${paddValue}px` }}>
      <code>{"@app.route('/api/users', methods=['GET'])"}</code>
      <br />
      <code>{'def get_users():'}</code>
      <br />
      <code style={{paddingLeft: `${pValue}px`}}>{"users = [{'id': 1, 'name': 'Alice'}, {'id': 2, 'name': 'Bob'}]"}</code>
      <br />
      <code style={{paddingLeft: `${pValue}px`}}>{"return jsonify(users)"}</code><br/><br/>
    </div>
  );
};
